export const environment = {
  production: true,
  apiUrl: 'https://compras-ti-api.itbeta2.com.br',
  authUrl: 'https://ldap-mock.itbeta2.com.br',
  budgetEmail: 'suporte.kn@itbeta2.com.br',

  clientId: 'ef432305-f823-48ec-a9f6-7debe5641224',
  clientSecret: '5c0b7139-6bed-46f1-9aff-d5202a8972d2',
  redirectUri: 'http://https://compras-ti.itbeta2.com.br/login-success',
  ssoUrl: 'https://sso-test.int.kn'
};
